const DataProvider = ({ provider }) => {
  const { name, addressLine1, city, state, zip } = provider;

  const splitName = name.split(",")[0];

  let tableName = splitName;

  if (addressLine1) tableName += `, ${addressLine1}`;
  if (city) tableName += `, ${city}`;
  if (state) tableName += `, ${state}`;

  return provider
    ? {
        ...provider,
        name: name.replace(', USA', ''), 
        displayName: splitName,
        tableValues: {
          name: splitName,
          fullName: provider.name,
          tableName
        },
      }
    : {};
};

export default DataProvider;
